<div>
  <div *ngIf="enableHeader" #banner class="banner">
    <div class="left-section">
      <button
        class="bannerbutton"
        type="button"
        id="btn-back"
        (click)="goBack()"
      >
        <img src="./assets/img/svg/arrow.svg" />
        <p class="d-none d-sm-flex">Seguro de arriendo</p>
      </button>
    </div>
    <div class="center-section">
      <img class="img-movil" name="logo" src="./assets/img/Capa_1-2.svg" />
    </div>
  </div>
  <app-discountbanner *ngIf="showBanner && showPromo"></app-discountbanner>
</div>
